import { Collections } from "../Home/Collections";

export function CollectionPage() {
    return(
        
            <Collections/>
        
    )
}